export default __webpack_public_path__ + "static/media/phase2-line.7326e6e3.svg";